import Vue from "vue";
import "./vue-global.js";

import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "axios";
import Rollbar from "rollbar";
import { sync } from "vuex-router-sync";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { SessionDataObject } from "@/types/interfaces";
import VueAwesomeSwiper from "vue-awesome-swiper";
import Carousel3d from "vue-carousel-3d";
import Buefy from "buefy";

// plugin styles
import "swiper/css/swiper.css";

// main styles
import "./styles/global.scss";

// utility styles
import "./css/tailwind.css";

sync(store, router);
// const unsync = sync(store, router); // done. Returns an unsync callback fn
// unsync() // Unsyncs store from router

Vue.use(VueAwesomeSwiper /* { default options with global component } */);
Vue.use(Carousel3d);
Vue.use(Buefy, {
    defaultIconPack: "fa"
});
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.prototype.$rollbar = new Rollbar({
    accessToken: "ddddca3adfd647b49da490fc741a4685",
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    environment: "production"
});

Vue.config.productionTip = false;

interface ThemeConfigInterface {
    sponsorVideos: Record<string, any>;
}

function handleThemeConfig(themeConfig: null | ThemeConfigInterface) {
    if (!themeConfig) return;

    if (Array.isArray(themeConfig.sponsorVideos)) {
        themeConfig.sponsorVideos = themeConfig.sponsorVideos.map(
            (videoObject: SessionDataObject) => {
                videoObject.isSponsorVideo = true;
                return videoObject;
            }
        );
    }

    store.commit("setThemeConfig", themeConfig);
    store.commit("setThemeConfigLoaded", true);
    store.commit("setCSSvariables");
}

// Set up from client config
let themeConfig = null;
const client = process.env.VUE_APP_MG_CLIENT;

// empty promise to resolve if we aren't using axios to get config
let configPromise = Promise.resolve();

if (client) {
    themeConfig = require(`./sites/${client}/config.json`);
    handleThemeConfig(themeConfig);
} else {
    configPromise = axios
        .get(`/config.json`)
        .then(response => {
            handleThemeConfig(response.data);
        })
        .catch(error => {
            console.log(error);
        });
}

function injectFontStylesheet(srcArray?: Array<string>) {
    if (Array.isArray(srcArray) && srcArray.length) {
        srcArray.forEach(src => {
            const css = document.createElement("link");
            css.href = src;
            css.rel = "stylesheet";
            document.head.append(css);
        });
    }
}

configPromise.then(async () => {
    injectFontStylesheet(store.getters.webfontSrc);

    const tokenString = localStorage.getItem("token") || "{}";
    await store.dispatch("loginUser", JSON.parse(tokenString)).finally(() => {
        new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount("#app");
    });
});
